import { Component, ElementRef, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { DeploymentClass } from 'src/app/models/instance-class';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UpgradePlanDialogComponent } from '../../service/upgrade-plan-dialog/upgrade-plan-dialog.component';
import { AutofillMonitor } from '@angular/cdk/text-field';
import { tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MeteringResourcesDialogComponent } from 'src/app/components/metering-resources-dialog/metering-resources-dialog.component';
import { MonitoringService } from 'src/app/services/api/monitoring.service';
import { ServiceCardService } from 'src/app/services/util/service-card.service';
import { Blueprint } from 'src/app/models/blueprints/blueprint';
import { Instance } from 'src/app/models/instance/instance';
import { ToastrService } from 'src/app/services/util/toastr.service';
import { translate } from '@jsverse/transloco';
import { TenantsService } from 'src/app/services/api/tenants.service';

@Component({
    selector: 'app-byob-dashboard',
    templateUrl: './byob-dashboard.component.html',
    styleUrls: ['./byob-dashboard.component.scss'],
    standalone: false
})

export class ByobDashboardComponent implements OnInit {
  systemHealthChartOptions: any;
  systemSecurityChartOptions: any;
  serviceAvailableChartOptions: any;
  isDataAvailable = false;
  noMonitoringData = false;
  activeStatus = 'HEALTHY';
  selectedItem: any = null;
  searchKey: any;
  filteredMonitoringTable: any;
  nonProdZone: any;
  isLoading = false;
  tenant: string;
  hasDeploymentClassA: boolean;
  isMonitoringDataLoaded = false;
  randomSuffix: string;
  blueprint: Blueprint;
  instance: Instance;
  private destroyRef = inject(DestroyRef);

  MonitoringRow: any =  [
    {
      category: 'Infra Monitoring',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['nginx', 'keycloak', 'azcopy', 'azcopy-dr', 'infkeycloak']
    },
    {
      category: 'Interfaces',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['activemq', 'artemis', 'kafka', 'activemqext', 'artemismq', 'bass-switchfileprocessing', 'interfaces']
    },
    {
      category: 'Transact',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['transact', 'autoscale']
    },
    {
      category: 'DES',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['des']
    },
    {
      category: 'FCM',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['fcm']
    },
    {
      category: 'Digital',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['fabric']
    },
    {
      category: 'DSF',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['dsf']
    },
    {
      category: 'Wealth',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['wealth/wealth-des/wealthinflux']
    },
    {
      category: 'TDE',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['tde/tdesql/sql/tde-mqsql/tde-atlas/tde-grafana/tde-graphite/tde-portal/tde-spark/tdh-azcopy/tdh-azcopy1']
    }
  ]
  tenantName: any;

  constructor(private authService: AuthService, private router: Router, private matDialog: MatDialog,
    public datepipe: DatePipe, private monitoringService: MonitoringService, private ServiceCardService: ServiceCardService,
    private toastrService: ToastrService, private tenantsService: TenantsService) {
    }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.tenantsService.getTenant(this.tenant)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((tenant: any) => {
      this.tenantName = tenant.tenantId;
    });
    const systemHealthStaticData = {
      running: [
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'Running' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'Running' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'Running' }
      ],
      issue: [
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'issue' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'issue' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'issue' }
      ],
      down: [
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'down' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'down' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'down' }
      ]
    };

    this.systemHealth(systemHealthStaticData);
    this.systemSecurity();
    this.serviceAvailability();
    this.loadInstances();
  }

  /**
   * Subscribes to the instanceData$ observable and evaluates the received data
   * Checks whether any instance contains a deploymentClass of "A"
   */
  loadInstances(): void {
    this.ServiceCardService.instanceData$.subscribe(data => {
      if (data) {
        const parentItem = data.find(item =>
          item.instances?.some(instance => instance.deploymentClass === DeploymentClass.A)
        );

        this.hasDeploymentClassA = !!parentItem;

        if (parentItem) {
          const prodInstance = parentItem.instances?.find(
            instance => instance.deploymentClass === DeploymentClass.A
          );

          if (prodInstance) {
            this.randomSuffix = prodInstance.randomSuffix;
            this.instance = prodInstance;
            this.blueprint = parentItem.blueprint;
          }

          this.loadMonitoring(this.randomSuffix);
        }
      }
    });
  }

  /**
   * Calls getRagStatus() to retrieve monitoring data
   * Maps each management zone into a summarized structure (Service, healthy, critical etc...)
   */
  loadMonitoring(randomSuffix): void {
    this.monitoringService.getRagStatus(this.tenantName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.isMonitoringDataLoaded = true;
        if (!data?.managementZones || data.managementZones.length === 0) {
          this.noMonitoringData = true;
          this.nonProdZone = null;
          this.selectedItem = null;
          this.filteredMonitoringTable = [];
          this.isLoading = false;
          return;
        }
        this.noMonitoringData = false;
        const zones = data?.managementZones?.map(zone => {
          const summary = this.summarizeZone(zone);
          return {
            name: zone.managementZone,
            services: summary.services,
            healthy: summary.healthy,
            critical: summary.critical,
            impacted: summary.impacted,
            overallStatus: this.getOverallStatus(summary),
            details: zone.rag_list
          };
        });
        this.searchKey = randomSuffix;
        this.nonProdZone = zones?.find(item =>item.name.toLowerCase().includes(this.searchKey?.toLowerCase()) );
        if (this.nonProdZone) {
          this.nonProdZone.donutStyle = this.getDonutStyle(this.nonProdZone);
          this.selectFirstItem();
        } else {
          this.isMonitoringDataLoaded = false;
          this.hasDeploymentClassA = false;
        }
        this.isLoading = false;
      },(error) => {
        this.isMonitoringDataLoaded = false;
        this.hasDeploymentClassA = false;

        this.toastrService.clear();
        setTimeout(() => {
        const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });    
    }

  /**
   * Automatically selects the first available item that matches
   * the currently active status within the non-production zone.
   */
  selectFirstItem(): void {
    const filteredItems = this.nonProdZone?.details.filter(
      item => this.ragToStatus(item.rag) === this.activeStatus
    );
    if (filteredItems?.length) {
      this.selectItem(filteredItems[0]);
    }
  }

  /**
   * Generates a summary of service health statistics for a given monitoring zone.
  * @param zone - The monitoring zone containing a rag_list of service statuses. 
  */
  summarizeZone(zone: any) {
    const summary = {
      services: zone.rag_list.length,
      healthy: 0,
      critical: 0,
      impacted: 0
    };
    zone.rag_list.forEach(item => {
      switch (item.rag) {
        case 'GREEN':
          summary.healthy++;
          break;
        case 'AMBER':
          summary.impacted++;
          break;
        case 'RED':
          summary.critical++;
          break;
      }
    });
    return summary;
  }

  /**
   * Determines the overall status of a zone based on its summarized health counts.
   * @param summary - The summarized health statistics of a zone.
  */ 
  getOverallStatus(summary: any): any {
    if (summary.impacted > 0) {
      return 'IMPACTED';
    }
    if (summary.critical > 0) {
      return 'CRITICAL';
    }
    return 'HEALTHY';
  }

  /**
  * Converts a RAG (Red-Amber-Green) value into a corresponding status string.
  */
  ragToStatus(rag: string): any {
    switch (rag) {
      case 'GREEN': return 'HEALTHY';
      case 'AMBER': return 'IMPACTED';
      case 'RED': return 'CRITICAL';
    }
  }

  /**
 * Filters the zone's detail items based on the currently active status.
 * @param zone - The monitoring zone containing detailed RAG entries
 */

  getFilteredItems(zone: any) {
    return zone.details.filter(
      item => this.ragToStatus(item.rag) === this.activeStatus
    );
  }

  /**
 * Handles changes to the selected status filter.
 */
  onStatusChange(status): void {
    this.activeStatus = status;
    this.selectedItem = null;
    this.filteredMonitoringTable = [];
    this.selectFirstItem();
  }

  /**
 * Handles selection of a monitoring item and filters the monitoring table accordingly.
 */
  selectItem(item: any) {
    this.selectedItem = item;
    const matchedRow = this.MonitoringRow.find(row =>
      row.category.toLowerCase().includes(this.selectedItem.product.toLowerCase())
    );
    this.filteredMonitoringTable = matchedRow ? [matchedRow] : [];
  }

  /**
   * Generates a CSS conic-gradient style object for rendering a donut chart
   * @param zone - The monitoring zone containing service health counts
   */
  getDonutStyle(zone: any) {
    const total = zone.services ?? 0;
    if (total === 0) {
      return {
        background: `conic-gradient(#d3d3d3 0deg 360deg)`
      };
    }
    const healthy = zone.healthy ?? 0;
    const impacted = zone.impacted ?? 0;
    const critical = zone.critical ?? 0;

    const healthyDeg = (healthy / total) * 360;
    const impactedDeg = (impacted / total) * 360;
    const criticalDeg = (critical / total) * 360;

    const hEnd = healthyDeg;
    const iEnd = hEnd + impactedDeg;
    const cEnd = iEnd + criticalDeg;

    return {
      background: `conic-gradient(
        #188038 0deg ${hEnd}deg,
        #EF7839 ${hEnd}deg ${iEnd}deg,
        #B53B20 ${iEnd}deg ${cEnd}deg
      )`
    };
  }

  navigateToBYOB(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, RouterSegments.CREATE]);
  }

  openPlanModal(): void {
    this.matDialog.open(UpgradePlanDialogComponent, {
      maxHeight: '100vh',
      minHeight: '90vh',
      backdropClass: 'upgrade-plans-backdrop',
      maxWidth: '1400px',
    });
  }

  goToComposeService(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.COMPOSE]);
  }

  goToReadMore(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.COMPOSABLE_BANKING]);
  }

  openMeteringResourcesModal(type): void {
    this.matDialog.open(MeteringResourcesDialogComponent, {
      maxHeight: '100vh',
      minHeight: '720px',
      backdropClass: 'upgrade-plans-backdrop',
      maxWidth: '1400px',
      minWidth: '1100px',
      data: {
        type,
      }
    });
  }

  systemHealth(res): void {
    const running = res.running.length;
    const issue = res.issue.length;
    const down = res.down.length;
    const count = running + issue + down;

    const date = this.datepipe.transform(new Date(), 'dd MMM yyyy');
    this.systemHealthChartOptions = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        selectedMode: false,
        show: true,
        bottom: '2%',
        left: 'center',
        itemGap: 25,
        itemWidth: 16,
        itemHeight: 16,
        textStyle: {
        color: '#003E75',
        fontFamily: 'worksans',
        fontSize: 14
        }
      },
      series: [
        {
          name: 'System Health',
          type: 'pie',
          radius: ['53%', '65%'],
          top: -60,
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'center',
            formatter: [
              '{boldFont|'+`${count}`+'}',
              '{normalFont|No of Services \n '+`${date}`+'}',
            ].join('\n'),
            rich: {
              boldFont: {
                fontSize: '50',
                fontWeight: '600',
                color: '#293276',
                fontFamily: 'worksans',
                lineHeight: 60
              },
              normalFont: {
                padding: 40,
                fontSize: '14',
                fontWeight: '400',
                color: '#293276',
                fontFamily: 'worksans',
                lineHeight: 20
              }
            },
            fontSize: '20'
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          color: [
            '#C7C52A',
            '#B53B20',
            '#F08261'
          ],
          data: [
            { value: `${running}`, name: running + ' Running' },
            { value: `${issue}`, name: issue + ' Issues' },
            { value: `${down}`, name: down + ' Down' }
          ]
        }
      ]
    };
  }

  systemSecurity(): void {
    this.systemSecurityChartOptions = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        selectedMode: false,
        show: true,
        bottom: '2%',
        left: 'center',
        itemGap: 25,
        itemWidth: 16,
        itemHeight: 16,
        textStyle: {
        color: '#003E75',
        fontFamily: 'worksans',
        fontSize: 14
        }
      },
      series: [
        {
          name: 'System Security',
          type: 'pie',
          radius: ['53%', '65%'],
          top: -50,
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'center',
            formatter: [
              '{boldFont|08}',
              '{normalFont|Security events in \n last 7 days}',
            ].join('\n'),
            rich: {
              boldFont: {
                fontSize: '50',
                fontWeight: '600',
                color: '#293276',
                fontFamily: 'worksans',
                lineHeight: 60
              },
              normalFont: {
                padding: 40,
                fontSize: '14',
                fontWeight: '400',
                color: '#293276',
                fontFamily: 'worksans',
                lineHeight: 20
              }
            },
            fontSize: '90'
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          color: [
            '#B53B20',
            '#293276',
            '#C7C52A',
            '#C9D9F2'
          ],
          data: [
            { value: 1, name: '1 Critical' },
            { value: 2, name: '2 High' },
            { value: 3, name: '3 Medium' },
            { value: 2, name: '2 Low' }
          ]
        }
      ]
    };
  }

  serviceAvailability(): void {
    this.serviceAvailableChartOptions = {
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['5th', '6th', '7th', '8th', '9th', '10th', '11th'],
        axisLabel: {
          color: '#293276',
        },
        axisLine: {
          lineStyle: {
          color: '#D1D9E3'
          }
        }
      },
      yAxis: {
        type: 'value',
        min: 99.6,
        max: 100,
        axisLabel: {
          formatter: '{fontStyle|'+`{value} %`+'}',
          rich: {
            fontStyle: {
              color: '#293276'
            },
          }
        },
        splitLine: {
          lineStyle: {
            color: '#D1D9E3'
          }
        },
      },
      series: [
        {
          name: 'Availability',
          data: [99.91, 99.94, 99.98, 99.99, 100, 99.99, 100],
          type: 'line',
          areaStyle: {
            color: '#EAF2FF',
            opacity: 0.5,
          },
          lineStyle: {
            color: '#293276',
          },
          markLine: {
            data: [{ type: 'average', name: 'Avg' }],
            label: {
              show: false
            },
            symbol: 'none',
            lineStyle: {
              color: '#B53B20'
            },
          }
        }
      ]
    };
  }
}
